var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stamp"},[_c('div',{staticClass:"stamp__icon",domProps:{"innerHTML":_vm._s(_vm.iconSrc)}}),_c('span',{staticClass:"stamp__text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }